export default __webpack_public_path__ + "static/media/NORLYSText-SemiBold.f42166ac.woff";